import React from 'react';

import { useParams } from 'react-router';

import { EventoFormComp, EventoListComp } from './components';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function EventoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['CALENDARIO_EVENTO_PERSONALIZADO_GERENCIAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <EventoListComp />
        </ListagemProvider>
    );
}

export function EventoForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();
    if (!hasFormPermission('CALENDARIO_EVENTO_PERSONALIZADO', id)) return alertNotPermission();

    return (
        <FormProvider>
            <EventoFormComp />
        </FormProvider>
    );
}
